<template>
  <div>
    <gs1-alert alertClass="success" iconClass="fa fa-check-circle color-forest">
      <i18n path="registered_to" tag="p">
        {{ companyName }}
      </i18n>
    </gs1-alert>
    <p>{{ $t('title') }}</p>
    <i18n path="message" tag="p">
      <a href="https://www.gs1-germany.de/service/kontakt/" target="_blank" rel="noopener">{{ $t('contact_gs1') }}</a>
    </i18n>
  </div>
</template>

<script>
import Gs1Alert from '@/components/alerts/Gs1Alert'
export default {
  name: 'ResultNoData',
  props: ['companyName'],
  components: {
    Gs1Alert
  },
  i18n: {
    messages: {
      de: {
        registered_to: 'Diese GTIN ist unter der Firma {0} registriert.',
        title: 'Leider haben wir keine weiteren Informationen zu diesem Produkt.',
        message: 'Bitte {0} wenn Sie Hilfe benötigen.',
        contact_gs1: 'kontaktieren Sie GS1'
      },
      en: {
        registered_to: 'This number is registered to {0}',
        title: 'Unfortunately we don’t have any information about the product.',
        message: 'Please {0} if you need help.',
        contact_gs1: 'contact GS1'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ResultNoData.vue